import { registerPlugin } from '@capacitor/core'

/** Raw payload returned by the native WeatherKitPlugin.getCurrentWeather. */
export interface WeatherKitNativeResult {
  /** ISO-8601 timestamp of the observation. */
  time: string
  /** Temperature in °C. */
  temperature: number
  /** Apparent ("feels like") temperature in °C. */
  apparentTemperature: number
  isDay: boolean
  /** One of the app's WeatherCondition union strings. */
  weatherCondition: string
  /** Cloud cover 0–100 (%). */
  cloudCover: number
  /** Wind speed in km/h. */
  windSpeed: number
  /** Wind direction in degrees (0–360). */
  windDirection: number
  /** Wind gust speed in km/h. */
  windGusts: number
  /** Precipitation intensity in mm/h. */
  precipitation: number
  /** UV index (0+). */
  uvIndex: number
}

export interface WeatherKitPlugin {
  /**
   * Fetch current weather for a coordinate via Apple WeatherKit, on-device.
   * iOS-only — rejects on non-iOS platforms / iOS < 16.
   */
  getCurrentWeather(opts: {
    latitude: number
    longitude: number
  }): Promise<WeatherKitNativeResult>
}

export const WeatherKitNative = registerPlugin<WeatherKitPlugin>('WeatherKit')
